import { FC } from "react";
import { motion } from "framer-motion";
import {
  useKeyboardVisibility,
  useDismissKeyboard,
  useHandleResize,
  handleOverlayClick,
} from "@shared/utils";
import { createPortal } from "react-dom";
import { IBottomSheetProps } from "@shared/interfaces";
import { bottomSheetVariants } from "./Animations";
import classNames from "classnames";

import styles from "./BottomSheet.module.scss";

export const BottomSheet: FC<IBottomSheetProps> = (props) => {
  const { onClose, isOpen, children, noPadding } = props;
  const viewportHeight = useHandleResize();
  const handleClick = handleOverlayClick(onClose);

  useKeyboardVisibility();
  useDismissKeyboard();

  if (!isOpen) return null;

  const content = (
    <>
      <div className={styles.overlay} onClick={handleClick} />
      <motion.div
        className={classNames(
          styles.bottomSheet,
          noPadding && styles.noPadding
        )}
        variants={bottomSheetVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ type: "spring", damping: 25, stiffness: 200 }}
        onClick={(e) => e.stopPropagation()}
        style={{ height: viewportHeight }}
        data-modal="open"
      >
        {children}
      </motion.div>
    </>
  );

  return createPortal(content, document.body);
};
